'use strict';
import { api } from '../../../utils/api-interceptor';

const detectLang = () => {
  const path = window?.location?.pathname || '';
  return path.startsWith('/en') ? 'en' : 'es';
};

export const UsersTokenService = {
  async checkExists(email) {
    const lang = detectLang();
    return api(
      `social-login?token=true&lang=${lang}&email=${encodeURIComponent(email)}`
    );
  },

  async createUser(data) {
    const lang = detectLang();
    return api(`social-login?token=true&lang=${lang}`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },
};
